// src/utils/url.js
import { api } from "api";
export const toAbsolute = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;           // already absolute
  const base = api.defaults?.baseURL?.replace(/\/+$/,"") || "";
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
};
